import './styles.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import AppLinks from 'Components/LayoutComponents/AppLinks'
import { coffeewebLogo } from 'Utils/Constants'
import useAnalytics from 'Utils/useAnalytics'
import { USER_EVENTS } from 'Utils/Constants/analyticsEvents'

const CreateAccountInfoModal = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { title, buttonText, infoMessage, className, navigationPath, state, testId, showCreateAccountButton = true, showLogo = true, customStyling } = props
  const { trackEvent } = useAnalytics()

  const navigateToLoginScreen = () => {
    trackEvent(USER_EVENTS.MODAL_REDIRECT)
    history.push({
      pathname: navigationPath,
      state
    })
  }

  return (
    <div className="create-account-info-modal" data-testid={testId}>
      <div className={`content-wrapper ${className}`} style={customStyling ?? {}} data-testid="content-wrapper">
        {showLogo && <img className="coffeeweb-logo" src={coffeewebLogo.coloredLogo} alt="colored-logo" data-testid="coffeeweb-colored-logo" />}
        {showCreateAccountButton && (
          <div className={`auth-screen-button ${className}`} onClick={navigateToLoginScreen} data-testid="auth-screen-button">
            {buttonText}
          </div>
        )}
        {title ? (
          <div className="title" data-testid="title">
            {title}{' '}
          </div>
        ) : (
          <div className="info">{infoMessage && <div>{infoMessage}</div>}</div>
        )}
        <div className="create-account-appLinks-wrapper" data-testid="app-links">
          <AppLinks />
        </div>
      </div>
    </div>
  )
}

export default CreateAccountInfoModal
